var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthVisibility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6099 5.21026C18.5762 6.22699 18.5762 7.77171 17.6099 8.78843C15.9801 10.5032 13.1809 12.8327 10.0013 12.8327C6.82171 12.8327 4.02255 10.5032 2.39272 8.78843C1.42638 7.77171 1.42638 6.22699 2.39272 5.21026C4.02255 3.49546 6.82171 1.16602 10.0013 1.16602C13.1809 1.16602 15.9801 3.49546 17.6099 5.21026Z",
    stroke: "#939094",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 6.99935C12.5013 8.38006 11.382 9.49935 10.0013 9.49935C8.62059 9.49935 7.5013 8.38006 7.5013 6.99935C7.5013 5.61864 8.62059 4.49935 10.0013 4.49935C11.382 4.49935 12.5013 5.61864 12.5013 6.99935Z",
    stroke: "#939094",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthVisibility);
export default __webpack_public_path__ + "static/media/auth-visibility.6dbc71cc57230e255444d2528982cf02.svg";
export { ForwardRef as ReactComponent };